import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  hoverEffect?: boolean;
}
export function Card({
  children,
  className = '',
  hoverEffect = false
}: CardProps) {
  return <div className={`
        bg-white rounded-xl border border-slate-100 p-6 
        ${hoverEffect ? 'transition-all duration-300 hover:shadow-xl hover:-translate-y-1 hover:border-slate-200' : 'shadow-sm'}
        ${className}
      `} data-id="element-160" data-mp="8beuxkrea255">
      {children}
    </div>;
}